export const MASTER_PARTNER_ROUTE="/partners";